<script>
import { cloneVNode, defineComponent } from 'vue'
import PageStack from 'page-stack-vue3'
import { RouterView } from 'vue-router'
import 'swiper/css'
import MRegisterPhone from '@/components/MRegisterPhone/MRegisterPhone.vue'

export default defineComponent({
  setup() {
    return function () {
      return (
        <>
          <RouterView>
            {({ Component, route }) => {
              return (
                <PageStack>
                  {Component && cloneVNode(Component, { key: route.path })}
                </PageStack>
              )
            }}
          </RouterView>
          <MRegisterPhone />
        </>
      )
    }
  },
})
</script>

<style lang="less" scoped>
.overlay-loading {
  :deep(.van-overlay) {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
  }
}
</style>
